export default __webpack_public_path__ + "static/media/b10-thumb.31c3f1f4.jpg";